/* tslint:disable */
/* eslint-disable */
/**
 * GLC.ClientPortal.Api (local) Portal BFF
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ErrorResult3,
  NotFoundErrorResult3,
  ResultOfLatestTransactionsViewModel,
  ValidationErrorResult3,
} from '../models';
import {
    ErrorResult3FromJSON,
    ErrorResult3ToJSON,
    NotFoundErrorResult3FromJSON,
    NotFoundErrorResult3ToJSON,
    ResultOfLatestTransactionsViewModelFromJSON,
    ResultOfLatestTransactionsViewModelToJSON,
    ValidationErrorResult3FromJSON,
    ValidationErrorResult3ToJSON,
} from '../models';

export interface TransactionsReportingGetLatestTransactionsRequest {
    clientId?: number;
}

/**
 * 
 */
export class TransactionsReportingApi extends runtime.BaseAPI {

    /**
     * Get the summary of the client\'s latest transactions
     */
    async transactionsReportingGetLatestTransactionsRaw(requestParameters: TransactionsReportingGetLatestTransactionsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<ResultOfLatestTransactionsViewModel>> {
        const queryParameters: any = {};

        if (requestParameters.clientId !== undefined) {
            queryParameters['clientId'] = requestParameters.clientId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/api/v1/transactions/latest`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ResultOfLatestTransactionsViewModelFromJSON(jsonValue));
    }

    /**
     * Get the summary of the client\'s latest transactions
     */
    async transactionsReportingGetLatestTransactions(requestParameters: TransactionsReportingGetLatestTransactionsRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<ResultOfLatestTransactionsViewModel> {
        const response = await this.transactionsReportingGetLatestTransactionsRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
